type WithId = { id?: string; _id?: string };

const getId = <T extends WithId>(item: T): string => item.id ?? item._id ?? '';

/**
 * Pins a deeplink-highlighted unavailable item first, then available items,
 * then any other nodes that remain.
 */
export function sortMenuSectionItemsForDeeplinkHighlight<T extends WithId>(
  items: T[],
  highlightedItemId: string
): T[] {
  if (!highlightedItemId || !items.length) {
    return items;
  }

  const highlighted: T[] = [];
  const rest: T[] = [];

  for (const item of items) {
    if (getId(item) === highlightedItemId) {
      highlighted.push(item);
    } else {
      rest.push(item);
    }
  }

  if (!highlighted.length) {
    return items;
  }

  return [...highlighted, ...rest];
}

export function shouldShowOtherAvailableOptionsHeader<T extends WithId>(
  items: T[],
  highlightedItemId?: string
): boolean {
  if (!highlightedItemId) {
    return false;
  }

  const hasHighlighted = items.some(item => getId(item) === highlightedItemId);
  const hasOther = items.some(item => getId(item) !== highlightedItemId);
  return hasHighlighted && hasOther;
}

export function getFirstAvailableMenuItemIndex<T extends WithId>(
  items: T[],
  highlightedItemId?: string
): number {
  if (!highlightedItemId) {
    return -1;
  }
  return items.findIndex(item => getId(item) !== highlightedItemId);
}
